/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

type ReturnTuple = [vp.CurrencyConversionTransactionResponse, (requestParams: vp.CurrencyConversionTransactionRequest) => void, () => void];

function useFetchCurrencyConversionTransaction({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.CurrencyConversionTransactionRequest>();
  const [response, setResponse] = useState<vp.CurrencyConversionTransactionResponse>({
    ErrorMessage: '',
    Success: false,
    Transactions: {
      TransactionID: "",
      SellCurrency: "",
      BuyCurrency: "",
      ConversionRate: "",
      SellAmount: "",
      BuyAmount: "",
    }
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.CurrencyConversionTransactionRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchCurrencyConversionTransaction(requestParams, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.CurrencyConversionTransactionRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Transactions: {
          TransactionID: "",
          SellCurrency: "",
          BuyCurrency: "",
          ConversionRate: "",
          SellAmount: "",
          BuyAmount: "",
        }
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchCurrencyConversionTransaction);
